/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {SwitchExampleDefault, SwitchExampleChecked, SwitchExampleErrorMessage, SwitchExampleSuffix, SwitchExampleSizes, SwitchExampleDisabled} from 'Docs/uilib/components/switch/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Unchecked Switch"
    }), "\n", _jsx(SwitchExampleDefault, {}), "\n", _jsx(_components.h3, {
      children: "Checked Switch"
    }), "\n", _jsx(SwitchExampleChecked, {}), "\n", _jsx(_components.h3, {
      children: "Checked Switch with error message"
    }), "\n", _jsx(SwitchExampleErrorMessage, {}), "\n", _jsx(_components.h3, {
      children: "Switch with suffix"
    }), "\n", _jsx(SwitchExampleSuffix, {}), "\n", _jsx(_components.h3, {
      children: "Switch in different sizes"
    }), "\n", _jsxs(_components.p, {
      children: ["As for now, there are two sizes. ", _jsx(_components.code, {
        children: "medium"
      }), " is the default size."]
    }), "\n", _jsx(SwitchExampleSizes, {}), "\n", _jsx(_components.h3, {
      children: "Switch in disabled state"
    }), "\n", _jsx(SwitchExampleDisabled, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
